import { Document, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';

const styles = StyleSheet.create({
  page: {
    padding: 10,
    flexDirection: 'column',
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  title: {
    fontSize: 13,
    fontWeight: 'bold',
    textDecoration: 'underline',
    textAlign: 'center',
    marginBottom: 20,
  },
  subtitle: {
    fontSize: 12,
    fontWeight: 900,
    marginTop: 10,
    textDecoration: 'underline',
  },
  subtitle2: {
    fontSize: 10,
    textDecoration: 'underline',
  },
  p: {
    fontSize: 10,
    wordWrap: 'break-word',
    textAlign: 'justify',
    marginBottom: 5,
    marginTop: 5,
  },
});

export const CreatePdf = ({ artistPDF, nft, contractAddress, rights, rightsEn, artType, nftInfos }) => {

  return (
    <Document style={styles.page}>
      <Page size="A4" wrap style={styles.page}>
        {/* ENGLISH */}
        <View style={styles.section}>
          <Text style={styles.title}>TERMS AND CONDITIONS OF SALE OF VISUAL ART NFT (INCLUDING A LICENCE TO USE)</Text>
          <Text style={styles.p}>
            Preamble: These Terms and Conditions of Sale for NFT and Rights Licensing (“TCNFT”) define the contractual relationship between the "PARTIES":
          </Text>
          <Text style={styles.p}>On the one hand the "SELLER", </Text>
          <Text style={styles.p}>Artist's name: {nft.artistName},</Text>
          {/* {artistPDF && (
            <>
              <Text style={styles.p}>
                {nft.artistDatas.civility} {nft.artistDatas.firstname} {nft.artistDatas.lastname}
              </Text>
              <Text style={styles.p}>{`Born on ${nft.artistDatas.civility === 'Mr' ? '' : 'Mrs'} at ${nft.artistDatas.birthdate}, `}</Text>
              <Text style={styles.p}>of nationality: {nft.artistDatas.nationality},</Text>
              <Text style={styles.p}>Residing at {nft.artistDatas.physicalAddress}</Text>
            </>
          )} */}
          {nft.artistEmail !== '' && (
            <Text style={styles.p}>Email address: {nft.artistEmail}</Text>
          )}
          <Text style={styles.p}>
            Holder of the address{' '}{nft.address} on the {nft.network} public blockchain shared electronic recording device.
          </Text>
          {/* {nftInfos.isWhitelisted ? <Text style={styles.p}> VERIFIED BY KYC BY THE SERVICE </Text> : <Text style={styles.p}> NON VERIFIED BY KYC </Text>} */}

          <Text style={styles.p}>And on the other hand, the "ACQUIRER",</Text>
          <Text style={styles.p}>
            Customer with full legal capacity and having called the smart contract of the non-fungible token ("NFT") issuance to acquire the NFT on the {nft.network} blockchain.
          </Text>
          <Text style={styles.p}>
            These TCNFT are applicable to the sale of NFTs and the licensing of rights relating to the WORKS associated with the NFT.
          </Text>
          <Text style={styles.p}>
            These TCNFT shall apply to the relationship between the PARTIES and shall prevail over any other general or special terms and conditions.
          </Text>
          <Text style={styles.p}>
            These applicable TCNFT have been obfuscated so as not to make 
            personal data readable and are stored on the IPFS storage service 
            accessible via the permanent link referred to in the metadata of the 
            NFT's smart contract on the {nft.network} blockchain. {/* on the {' '}{contractAddress}{'. '} */}
          </Text>
          {nft.artistEmail !== '' && (
            <Text style={styles.p}>
              The ACQUIRER may request the SELLER further information by contacting: {' '}{nft.artistEmail}.
            </Text>
          )}
         {/*  <Text style={styles.p}> The hash of the non-obfuscated version of the TCNFT is inserted in the metadata of the NFT.</Text> */}
          <Text style={styles.subtitle}> Article 1. Purpose of the contract</Text>
          <Text style={styles.subtitle2}> 1.1. Description</Text>
          <Text style={styles.p}>
            The WORK, of which the SELLER has the entirety of the copyrights, which is the subject of the present TCNFT, is described as follows:
          </Text>
          <Text style={styles.p}>- Title:  {nft.artworkName} </Text>
          <Text style={styles.p}>- Size:  {nft.size}</Text>
          <Text style={styles.p}>- Date of realization:  {nft.date} </Text>
          <Text style={styles.p}>- Detailed description: {nft.description}</Text>
          <Text style={styles.subtitle2}>1.2.	Technical identification </Text>
          <Text style={styles.p}>
            The WORK is recorded on a computer file in {artType} format accessible on IPFS storage service referred to in the metadata of the smart contract of the NFT of address
            {' '}{nft.address}, on the public {nft.network} blockchain. The NFT complies with the ERC-721 standard.
          </Text>
          <Text style={styles.subtitle2}>1.3.	Purpose</Text>
          <Text style={styles.p}> The SELLER grants to the ACQUIRER, who accepts it: </Text>
          {nft.copy.unique && <Text style={styles.p}>- full ownership of the single NFT </Text>}
          {nft.copy.numbered && <Text style={styles.p}>- full ownership of one original numbered copy of the 1-{nft.supplyNumber} NFT (compatible only with non-exclusive license) </Text>}
          {nft.copy.limited && <Text style={styles.p}>- full ownership of one limited edition copy of the 1-{nft.supplyNumber} NFT (compatible only with non-exclusive license) </Text>}
          <Text style={styles.p}>- the rights of use referred to in Article 2.</Text>
          {/* Article 2 */}
          <Text style={styles.subtitle}>Article 2. Scope of the license of rights of use</Text>
          <Text style={styles.subtitle2}>2.1. Exclusivity</Text>
          <Text style={styles.p}>
            This ASSIGNMENT includes the grant of
            {nft.exclusive
              ?
              <Text> exclusive (compatible only with the sale of single NFT) </Text>
              :
              <Text> non-exclusive </Text>
            }
            rights to use the WORK.
          </Text>
          <Text style={styles.subtitle2}>2.2. Territorial scope</Text>
          <Text style={styles.p}>The rights of use are granted for the whole world.</Text>
          <Text style={styles.subtitle2}>2.3. Duration</Text>
          <Text style={styles.p}>
            The rights of use are granted for
            {nft.rightsDuration !== 'legal' ? (
              <Text style={styles.p}>
                {' '}
                the duration of {nft.rightsDuration} years from the issuance of the non-fungible token ("NFT") of address {nft.address} on the {nft.network} public blockchain.
              </Text>
            ) : (
              <Text style={styles.p}>
                {' '}
                the legal duration of protection of intellectual property rights as set by French and foreign legislation,
                as well as current or future international conventions, including any extensions to the duration of protection,
                from the date of signature of this contract
              </Text>
            )}
          </Text>
          <Text style={styles.subtitle2}>2.4. Scope of the rights granted to the NFT holder under the associated user license</Text>
          <Text style={styles.p}> The rights of use granted include the following rights:</Text>

          {rightsEn.map((right, i) => (
            <Text style={styles.p} key={i}>
              {right}
            </Text>
          ))}

          {nft.rightAdapt && (
            <Text style={styles.p}>
                - The right to adapt all or part of the WORK, for all audiences, in 
                particular in the form of a multimedia work, offline or online, extracts 
                or summaries, as well as the right to reproduce these adaptations on 
                any current or future analog or digital medium. With respect to the 
                moral rights of the author, this right includes the right to extract parts 
                of the WORK and to publish them on any analog or digital medium, in 
                association with other contributions or not 
            </Text>
          )}  

          {nft.addLogo && (
            <Text style={styles.p}>
                - The right to include the logo of his company or companies on the 
                WORK, if applicable.
            </Text>
          )}

          {nft.merchandising && (
            <Text style={styles.p}>
                - Secondary exploitation right to manufacture, distribute, sell, rent, 
                publish and more generally to market in all its forms (including 
                interactive, exploited by all processes of electronic communication 
                and/or mobile radio communication) or use (including for any 
                advertising or promotional purpose, or self-promotional) products or 
                objects distributed in the trade which incorporate in their content, 
                substance, form, decoration, packaging and/or presentation, all or 
                part of the WORK.
            </Text>
          )}

          <Text style={styles.p}>
            It is reminded that the moral rights are non-transferable and must be respected by any third party and
            that all the economic rights not expressly mentioned in this article 2.4 are not granted within the framework of the license of use.
          </Text>
          <Text style={styles.subtitle2}>2.5. Credits</Text>
          <Text style={styles.p}>
            The ACQUIRER shall mention on the WORK or in an insert provided for this purpose and in the metadata linked to the file,
            the name of the SELLER and of the author if different from the SELLER as well as the Title of the WORK in the context of
            any reproduction or representation of the WORK referred to in article 2.4.
          </Text>
          {/* Article 3 */}
          <Text style={styles.subtitle}>Article 3. Price of the transfer</Text>
          <Text style={styles.p}>
            In consideration of the NFT relating to the WORK and the associated 
            rights of use, the ACQUIRER undertakes to pay the SELLER a 
            remuneration of a lump sum which will be determined at the time of 
            the meeting of wills formalized by the validation of the ACQUIRER's 
            price offer by the SELLER and the execution of the smart contract 
            transferring the NFT between two public addresses on the {nft.network} public blockchain.
            The price may result from an exchange with crypto assets or tokens expressly accepted by the SELLER.
          </Text>
          {/* Article 4 */}
          <Text style={styles.subtitle}>Article 4. Guarantees</Text>
          <Text style={styles.subtitle2}>4.1. Guarantee of copyright ownership</Text>
          <Text style={styles.p}>
            The SELLER declares that he is the sole owner of the copyrights, of the related rights and, in general, that he holds all the authorizations necessary for
            the exploitation of the WORKS and guarantees to the ACQUIRER the quiet and full enjoyment of all easements of the rights that are the subject of the contract,
            against all disturbances, claims and evictions of any kind.{' '}
          </Text>
          <Text style={styles.p}>
            The SELLER shall be responsible for any claim or demand, whether amicable or judicial, from a third party claiming to have rights over the WORK and/or the NFT and guarantees the ACQUIRER against all claims.
            The SELLER undertakes to bear all costs resulting from any recourse, in particular legal costs, proceedings, expert fees and lawyers' fees,
            as well as to compensate the ACQUIRER for the entirety of the prejudice suffered and in particular for all damages and other indemnities that may be requested of him by way of settlement,
            any damages, expenses, incidental costs, losses and lost profits resulting from a possible dispute.
          </Text>
          {nft.exclusive && nft.noReissue && (
            <>
              <Text style={styles.subtitle2}>4.2. Guarantee of exclusivity</Text>
              <Text style={styles.p}>
                The SELLER warrants that it has not assigned or granted the rights hereunder to any third party. The SELLER undertakes not to assign or grant the rights set forth herein to any third party,
                in particular not to issue any additional NFT granting all or part of the rights of use set forth in these TCNFT.
              </Text>
            </>
          )}
          {!nft.exclusive && nft.noReissue && (
            <>
              <Text style={styles.subtitle2}>4.2. Guarantee of limitation of competing rights</Text>
              <Text style={styles.p}>
                The SELLER warrants that he has not assigned or licensed the rights hereunder other than to the extent of{' '}
                {nft.supplyNumber} NFT. he SELLER undertakes not to transfer or grant the rights hereunder to any new third party after the sale of{' '}
                {nft.supplyNumber} NFTs, in particular not to issue additional NFTs granting all or part of the rights of use referred to in these TCNFT.
              </Text>
            </>
          )}
          <Text style={styles.subtitle2}>4.3. Guarantee against infringement of third-party rights</Text>
          <Text style={styles.p}>
            The SELLER declares that the WORK does not include any element likely to harm the interests of a third party,
            or of a nature to found a legal action on the basis of counterfeiting or infringement of privacy,
            of the right to an image or likely to be considered as an infringement of public policy, an act of defamation, slander, libel or insult.
          </Text>
          <Text style={styles.subtitle2}>4.4. Precautions against unauthorized use</Text>
          <Text style={styles.p}>
            The SELLER declares that all precautions are and/or will be taken to limit as much as possible the risks of piracy and/or any unauthorized use of the WORKS.
          </Text>
          <Text style={styles.subtitle2}>4.5. Guarantees against deletion of links or files in the metadata</Text>
          <Text style={styles.p}>
            The SELLER declares that all precautions are and/or will be taken to 
            limit as much as possible the risks of inactive links or deletion of files 
            referred to in the NFT metadata.
            The ACQUIRER shall keep at least one copy of the files referred to in the NFT by 
            his own means (personal hard drive, personal cloud, storage 
            services...). The SELLER agrees in advance to the reissuance of a 
            substitute NFT with the same specifications as the NFT that has 
            become inactive by a company specializing in the issuance of NFTs 
            and crypto-assets under the supervision of a bailiff or any other 
            authorized professional who has previously noted the inactive nature 
            of the NFT. This exceptional operation will be carried out at the 
            ACQUIRER's expense. 
          </Text>
          <Text style={styles.subtitle2}>4.6. Guarantees and indemnities</Text>
          <Text style={styles.p}>
            In the event that the ACQUIRER should be the object of a request from a third party or of a complaint as a result of the distribution of the WORK, which would have its origin in the SELLER's failure to comply
            with its obligations and guarantees as set forth herein, THE SELLER undertakes to indemnify the ACQUIRER for all the financial consequences related to such a claim or appeal.
          </Text>
          {/* Article 5 */}
          <Text style={styles.subtitle}>Article 5. Risks not covered</Text>
          <Text style={styles.subtitle2}>5.1. Economic risks</Text>
          <Text style={styles.p}>The ACQUIRER acknowledges that he is aware of the following economic risks: </Text>
          <Text style={styles.p}>- the NFT may lose all or part of its value due to changes in the market price;</Text>
          <Text style={styles.p}>
            - digital assets, tokens and NFTs may be subject to significant price fluctuations up and down. The magnitude of such fluctuations is difficult to predict and cannot be guaranteed;
          </Text>
          <Text style={styles.p}>
            - the ACQUIRER has no guarantee that he will be able to list the NFT on a secondary market or platform and the ACQUIRER has no guarantee that he will be able to resell the NFT.
          </Text>
          <Text style={styles.subtitle2}>5.2. Technological risks</Text>
          <Text style={styles.p}>The ACQUIRER acknowledges the following technological risks: </Text>
          <Text style={styles.p}>
            - The NFT is stored in an electronic wallet to which a unique private key is associated that makes the NFT available. Consequently, the theft, loss or hacking of private keys implies the permanent loss of the NFT.
            The ACQUIRER is also responsible for the secure storage of the private key in his wallet, necessary to receive and transfer the NFT. Loss or theft of the private key is equivalent to loss of the NFT assigned to the wallet;
          </Text>
          <Text style={styles.p}>
            - In the event that the ACQUIRER transfers to a wallet that is incompatible with the NFT's smart contract, the ACQUIRER will normally no longer be able to access the NFT. The ACQUIRER bears full responsibility for the decision as to which portfolio is used;
          </Text>
          <Text style={styles.p}>
            - In case of subsequent creation by the ACQUIRER of a smart contract on the transferring NFT, the ACQUIRER bears full responsibility for the choice of the standard or ad hoc smart contract used and for any possible bugs and security flaws.{' '}
          </Text>
          <Text style={styles.p}>
            - The chosen protocol is the {nft.network} public blockchain, which runs the risk of a 51% attack on the consensus system that could corrupt the data recorded on the blockchain.
          </Text>
          <Text style={styles.subtitle2}>5.3. Regulatory risks</Text>
          <Text style={styles.p}>The ACQUIRER acknowledges being aware of the following regulatory risks: </Text>
          <Text style={styles.p}>
            - Legal and tax risks related to the determination of the applicable law, in particular in the event of resale of the NFT, are to be taken into account by the ACQUIRER and the SELLER cannot guarantee a legal or tax qualification due to the diversity of national laws applicable in this area and their evolution, potentially unfavorable to the ACQUIRER's interests;
          </Text>
          <Text style={styles.p}>
            - Regulatory or normative changes could have an impact on the operation of the public blockchain {nft.network} used for the NFT, which could generate various legal and fiscal risks with consequences, in particular, on the conditions or the very possibility of reselling the NFT;
          </Text>
          <Text style={styles.p}>
            - Risks related to reinforced obligations of identification of the ACQUIRER to keep, use and/or resell the NFT must be taken into account and cannot be covered by the SELLER.
          </Text>
          {/* Article 6 */}
          <Text style={styles.subtitle}>Article 6. Defense of rights </Text>
          <Text style={styles.p}>The ACQUIRER does not have the right to take direct action for infringement.</Text>
          {/* Article 7 */}
          <Text style={styles.subtitle}>Article 7. Execution </Text>
          <Text style={styles.subtitle2}>7.1. Automatic enforcement by smart contract</Text>
          <Text style={styles.p}>
            The transfer of the NFT to the ACQUIRER's wallet is carried out automatically by sending the amounts determined in accordance with Article 3, via smart contract on the public {nft.network} blockchain.
            The granting of the rights of use referred to in Article 2 occurs as soon as the NFT is placed in the possession of the ACQUIRER's wallet and continues as long as the NFT is held on a wallet of which the ACQUIRER is the holder.
          </Text>
          <Text style={styles.subtitle2}>7.2. Waiver of right of withdrawal</Text>
          <Text style={styles.p}>
            In accordance with applicable law, the ACQUIRER expressly waives his right of withdrawal upon delivery of the digital assets formalized by the NFT by automatic execution of the smart contract. This sale of NFT is firm and final. No request for retraction, cancellation or refund will be processed.
          </Text>
          <Text style={styles.subtitle}>Article 8. Resale</Text>
          <Text style={styles.subtitle2}>8.1. Conditions for resale</Text>
          <Text style={styles.p}>
            The ACQUIRER is authorized to resell the NFT with the associated rights of use and secondary rights as stipulated in these TCNFT to any third party of his choice without prior agreement from the SELLER.
            The NFT may not be resold by the ACQUIRER without transfer of the associated rights of use and vice versa.
            The transfer of the NFT between electronic wallets held by the ACQUIRER is not considered a resale but a simple internal movement.
          </Text>
          {nft.resale && (
            <>
              <Text style={styles.subtitle2}>8.2. Contractual resale right</Text>
              <Text style={styles.p}>
                The ACQUIRER shall ensure that in the event of resale of the NFT to 
                a third party by way of a smart contract or by way of transfer of 
                ownership of a decentralized, centralized, digital or physical electronic 
                portfolio that a percentage of {nft.resaleValue} % of the resale will normally be paid automatically or, in the event that this is 
                not possible, will be paid back to the SELLER within a maximum 
                period of 14 days.
                If the SELLER is different from the author, the SELLER will be 
                responsible for the payment of these sums to the author, once 
                received.
                This amount will have to be paid on the wallet identified by the address{' '}{nft.address} of the {nft.network} public blockchain.
              </Text>
            </>
          )}
          {/* Article 9 */}
          <Text style={styles.subtitle}>Article 9. Applicable law</Text>
          <Text style={styles.p}> The present TCNFT are governed by French law.</Text>
          {/* Article 10 */}
          <Text style={styles.subtitle}>Article 10. Dispute resolution</Text>
          <Text style={styles.p}>
            The Parties shall attempt to settle any dispute arising from the interpretation or execution of these TCNFT amicably. Failing that, any dispute will be submitted to the jurisdiction of the Paris Court of Appeal.
          </Text>
        </View>
      </Page>

      <Page size="A4" wrap style={styles.page}>
        {/* FRENCH */}
        <View style={styles.section}>
          <Text style={styles.title}>CONDITIONS GENERALE DE VENTE DE NFT D’ŒUVRE VISUELLE (ASSORTIE D’UNE LICENCE D’UTILISATION DE L’ŒUVRE)</Text>
          <Text style={styles.p}>
            Préambule : Les présentes Conditions Générales de Vente de NFT et de Licence de Droits (« CGVNFT ») définissent les relations
            contractuelles entre les « PARTIES » :
          </Text>
          <Text style={styles.p}>D’une part le « VENDEUR»,</Text>
          <Text style={styles.p}>Nom d'artiste : {nft.artistName},</Text>
          {/* {artistPDF && (
            <>
              <Text style={styles.p}>
                {nft.artistDatas.civility} {nft.artistDatas.firstname} {nft.artistDatas.lastname}
              </Text>
              <Text style={styles.p}>{`né${nft.artistDatas.civility === 'Mr' ? '' : 'e'} le ${nft.artistDatas.birthdate}, `}</Text>
              <Text style={styles.p}>de nationalité {nft.artistDatas.nationality},</Text>
              <Text style={styles.p}>demeurant {nft.artistDatas.physicalAddress}</Text>
            </>
          )} */}
          {nft.artistEmail !== '' && (
            <Text style={styles.p}>Adresse email : {nft.artistEmail}</Text>
          )}
          <Text style={styles.p}>
            détenteur de l’adresse {nft.address} sur le dispositif électronique d’enregistrement partagé (« DEEP ») blockchain publique {nft.network}.
          </Text>
          {/* {nftInfos.isWhitelisted ? <Text style={styles.p}> VERIFIE PAR KYC</Text> : <Text style={styles.p}> NON VERIFIE PAR KYC </Text>} */}
          <Text style={styles.p}>Et d’autre part, l’« ACQUEREUR »,</Text>
          <Text style={styles.p}>
            Client disposant de sa pleine capacité juridique et ayant appelé le contrat intelligent de l’émission du jeton non fongible (« NFT ») pour
            acquérir le NFT sur le DEEP de la blockchain {nft.network}
          </Text>
          <Text style={styles.p}>
            Les présentes CGVNFT sont applicables aux ventes de NFT et à l’octroi de licence de droits sur les œuvres rattachées au NFT.
          </Text>
          <Text style={styles.p}>
            Les CGVNFT sont applicables à la relation entre les PARTIES et prévalent sur toutes autres conditions générales ou particulières.
          </Text>
          <Text style={styles.p}>
            Les présentes CGVNFT applicables ont été obfusquées pour ne pas rendre lisibles les données personnelles et sont enregistrées sur le
            service de stockage IPFS accessible via le lien permanent visé dans les métadonnées du contrat intelligent du NFT{/* de l’adresse
            {' '}{contractAddress} */} sur le DEEP blockchain publique {nft.network}.   
          </Text>
          {nft.artistEmail !== '' && (
            <Text style={styles.p}>
              L’acquéreur peut demander une version non obfusquée des CGVNFT en adressant un email à l’adresse email : {nft.artistEmail}.
            </Text>
          )}
          {/* <Text style={styles.p}> Le hash de la version non obfusquée des CGVNFT est inséré dans les métadonnées du NFT.</Text> */}
          <Text style={styles.subtitle}> Article 1er. Objet du contrat</Text>
          <Text style={styles.subtitle2}> 1.1. Description</Text>
          <Text style={styles.p}>
            L’ŒUVRE, dont le VENDEUR dispose de l’intégralité des droits patrimoniaux d’auteur, qui fait l’objet des présentes CGVNFT, est décrite
            comme suit :
          </Text>
          <Text style={styles.p}>- Titre : {nft.artworkName} </Text>
          <Text style={styles.p}>- Taille : {nft.size} </Text>
          <Text style={styles.p}>- Date de réalisation : {nft.date} </Text>
          <Text style={styles.p}>- Description détaillée : {nft.description}</Text>
          <Text style={styles.subtitle2}>1.2. Identification technique</Text>
          <Text style={styles.p}>
            L’ŒUVRE est inscrite sur un fichier informatique au format {artType} {/* conservée applicables sont celles enregistrées  */}sur le service de
            stockage IPFS accessible visé dans les métadonnées du contrat intelligent du NFT de l’adresse{' '}{nft.address}, sur le DEEP blockchain
            publique {nft.network}. Le NFT respecte le standard ERC-721.
          </Text>
          <Text style={styles.subtitle2}> 1.3. Objet</Text>
          <Text style={styles.p}>Le VENDEUR octroie à l’ACQUEREUR, qui l’accepte : </Text>
          {nft.copy.unique && <Text style={styles.p}>- la propriété pleine et entière sur le NFT unique </Text>}
          {nft.copy.numbered && <Text style={styles.p}>- un exemplaire original numéroté des 1-{nft.supplyNumber} NFT </Text>}
          {nft.copy.limited && <Text style={styles.p}>- un exemplaire en série limitée des 1-{nft.supplyNumber} NFT portant sur l’ŒUVRE</Text>}
          <Text style={styles.p}>- les droits d’utilisation visés à l’article 2.</Text>
          <Text style={styles.subtitle}>Article 2. Portée de la licence de droits d’utilisation</Text>
          <Text style={styles.subtitle2}>2.1. Exclusivité</Text>
          <Text style={styles.p}>
            La présente CESSION inclut l’octroi de droits d’utilisation
            {nft.exclusive ? <Text> à titre exclusif </Text> : <Text> à titre non-exclusif de l’ŒUVRE.</Text>}
          </Text>
          <Text style={styles.subtitle2}>2.2. Portée territoriale</Text>
          <Text style={styles.p}> Les droits d’utilisation sont consentis pour le monde entier.</Text>
          <Text style={styles.subtitle2}>2.3. Durée</Text>
          <Text style={styles.p}>
            Les droits d’utilisation sont consentis pour
            {nft.rightsDuration !== 'legal' ? (
              <Text style={styles.p}>
                {' '}
                la durée de {nft.rightsDuration} années à compter de l’émission de jeton non fongible (« NFT ») de l’adresse {nft.address} sur le DEEP
                blockchain publique {nft.network}.
              </Text>
            ) : (
              <Text style={styles.p}>
                {' '}
                la durée légale de protection des droits de propriété intellectuelle telle que fixée par la législation tant française qu’étrangère,
                ainsi que les conventions internationales, actuelles ou futures, y compris éventuellement les prorogations apportées à la durée de
                protection, à compter de la date de signature du présent contrat.
              </Text>
            )}
          </Text>
          <Text style={styles.subtitle2}>2.4. Étendue des droits consentis au détenteur du NFT au titre de la licence d’utilisation associée</Text>
          <Text style={styles.p}> Les droits d’utilisation consentis incluent les droits suivants :</Text>
          {rights.map((right, i) => (
            <Text style={styles.p} key={i}>
              {right}
            </Text>
          ))}

          {nft.rightAdapt && (
            <Text style={styles.p}>
                - Droit d’adapter tout ou partie de l’ŒUVRE, pour tous publics, 
                notamment sous forme d’œuvre multimédia, hors ligne ou en ligne, 
                d’extraits ou résumés, ainsi que le droit de reproduire ces adaptations 
                sur tout support analogique ou numérique, actuel ou futur. Dans le 
                respect du droit moral de l’auteur, ce droit inclut la faculté d’extraction 
                de parties de l’ŒUVRE et de les publier sur tout support analogique 
                ou numérique, en association ou non avec d’autres contributions. 
            </Text>
          )}

          {nft.addLogo && (
            <Text style={styles.p}>
                - Droit d’incruster le logo de sa ou ses sociétés sur l’ŒUVRE, le cas 
                échéant.
            </Text>
          )}

          {nft.merchandising && (
            <Text style={styles.p}>
                - Droit d’exploitation secondaire de fabriquer, distribuer, vendre, louer, 
                éditer et plus généralement commercialiser sous toutes ses formes (y 
                compris interactives, exploitées par tous procédés de communication 
                électronique et/ou de radiocommunication mobile) ou l’utilisation (y 
                compris pour toute destination publicitaire ou promotionnelle, ou auto-
                promotionnelle) des produits ou des objets diffusés dans le commerce 
                qui incorporent dans leur contenu, substance, dans leur forme, 
                décoration, conditionnement et/ou présentation, tout ou partie de 
                l’ŒUVRE.
            </Text>
          )}

          <Text style={styles.p}>
            Il est rappelé que le droit moral est incessible et doit être respecté par tout tiers et que l’ensemble des droits patrimoniaux non visés
            expressément au présent article 2.4 ne sont pas octroyés dans le cadre de la licence d’utilisation.
          </Text>
          <Text style={styles.subtitle2}>2.5. Crédits</Text>
          <Text style={styles.p}>
            L’ACQUEREUR accepte de mentionner sur l’ŒUVRE ou dans un encart prévu à cet effet et dans des métadonnées liées au fichier, le nom du
            VENDEUR et de l’auteur s’il est différent du VENDEUR ainsi que le Titre de l’ŒUVRE dans le cadre de toute reproduction ou représentation
            de l’ŒUVRE visées à l’article 2.4.
          </Text>
          <Text style={styles.subtitle}>Article 3. Prix de la cession</Text>
          <Text style={styles.p}>
            En contrepartie du NFT portant sur l’ŒUVRE et des droits d’utilisation 
            associés, l’ACQUEREUR s’engage à payer au VENDEUR une 
            rémunération d’un montant forfaitaire qui sera déterminé au moment 
            de la rencontre des volontés formalisée par la validation de l’offre de 
            prix de l’ACQUEREUR par le VENDEUR et l’exécution du contrat 
            intelligent portant transfert du NFT entre deux adresses publiques sur 
            le DEEP blockchain publique {nft.network}. 
            Le prix pourra résulter d’un échange avec des cryptoactifs ou jetons 
            acceptés expressément par le VENDEUR.
          </Text>
          <Text style={styles.subtitle}>Article 4. Garanties</Text>
          <Text style={styles.subtitle2}>4.1. Garantie de titularité des droits d’auteur</Text>
          <Text style={styles.p}>
            Le VENDEUR déclare être seul et unique titulaire des droits patrimoniaux d’auteur, des droits voisins et de manière générale détenir
            l’ensemble des autorisations nécessaires à l’exploitation paisible des ŒUVRES et garantit à l’ACQUEREUR la jouissance libre et entière de
            toutes servitudes des droits faisant l’objet du contrat, contre tous troubles, revendications et évictions quelconques.{' '}
          </Text>
          <Text style={styles.p}>
            Le VENDEUR sera responsable de toute réclamation ou demande éventuelle, amiable ou judiciaire issue d'un tiers prétendant disposer des
            droits sur l'OEUVRE et/ou le NFT et garantit l'ACQUEREUR contre tous recours. Le VENDEUR s'engage à prendre à sa charge la totalité des
            frais résultants de tous recours, notamment les frais judiciaires, de procédure, d’expertise et honoraires d’avocats, ainsi qu’à
            indemniser l'ACQUEREUR de l'intégralité du préjudice subi et notamment de tous les dommages-intérêts et autres indemnités qui lui seraient
            demandées à titre transactionnel, toutes condamnations judicaires, frais et accessoires, pertes et manques à gagner résultant d’un éventuel
            différend.
          </Text>
          {nft.exclusive && nft.noReissue && (
            <>
              <Text style={styles.subtitle2}>4.2. Garantie d’exclusivité </Text>
              <Text style={styles.p}>
                En ce sens, le VENDEUR garantit n’avoir cédé ou concédé les droits objets des présentes à aucun tiers. Le VENDEUR s’engage à ne pas
                céder ou concéder les droits objets des présentes à aucun tiers, notamment à ne pas émettre de NFT complémentaires octroyant tout ou
                partie des droits d’utilisation visés dans les présentes CGVNFT.
              </Text>
            </>
          )}
          {!nft.exclusive && nft.noReissue && (
            <>
              <Text style={styles.subtitle2}>4.2. Garantie de limitation des droits concurrents</Text>
              <Text style={styles.p}>
                En ce sens, le VENDEUR garantit n’avoir cédé ou concédé les droits objets des présentes autrement que dans la limite de{' '}
                {nft.supplyNumber} NFT. Le VENDEUR s’engage à ne céder ou concéder les droits objets des présentes à aucun nouveau tiers à l’issue de
                la vente des {nft.supplyNumber} NFT, notamment à ne pas émettre de NFT complémentaires octroyant tout ou partie des droits
                d’utilisation visés dans les présentes CGVNFT.
              </Text>
            </>
          )}
          <Text style={styles.subtitle2}>4.3. Garantie contre l’atteinte aux droits des tiers </Text>
          <Text style={styles.p}>
            Le VENDEUR déclare que l’ŒUVRE ne comporte aucun élément susceptible de nuire aux intérêts d’un tiers, ou de nature à fonder une action en
            justice sur le fondement de la contrefaçon ou l’atteinte à la vie privée, au droit à l’image ou susceptibles d’être considéré comme une
            atteinte aux bonnes mœurs, un acte de diffamation ou d’injure.
          </Text>
          <Text style={styles.subtitle2}>4.4. Précautions contre les utilisations non-autorisées </Text>
          <Text style={styles.p}>
            Le VENDEUR déclare que toutes les précautions sont et/ou seront prises pour limiter au maximum les risques de piratage et/ou toute
            utilisation non-autorisée des ŒUVRES.
          </Text>
          <Text style={styles.subtitle2}>4.5. Garanties contre la suppression des liens ou fichiers visés dans les métadonnées</Text>
          <Text style={styles.p}>
            Le VENDEUR déclare que toutes les précautions sont et/ou seront 
            prises pour limiter au maximum les risques de liens inactifs ou
            suppression de fichiers visés dans les métadonnées du NFT. 
            L’ACQUEREUR conservera a minima une copie des fichiers visés par 
            les métadonnées du NFT par ses moyens propres (disque dur 
            personnel, cloud personnel, services de stockage…). Le VENDEUR 
            accepte par avance l’émission d’un NFT de substitution avec les 
            mêmes spécifications que le NFT devenu inactif par une société 
            spécialisée dans l’émission de NFT et crypto-actifs sous le contrôle 
            d’un commissaire de justice ou tout autre professionnel habilité ayant 
            constaté préalablement le caractère inactif du NFT. Cette opération 
            exceptionnelle sera réalisée aux frais de l’ACQUEREUR.
          </Text>
          <Text style={styles.subtitle2}>4.6. Garanties et indemnisations</Text>
          <Text style={styles.p}>
            Dans le cas où l’ACQUEREUR ferait l’objet d’une demande d’un tiers ou d’un recours du fait de la diffusion de l’ŒUVRE qui aurait pour
            origine le non-respect du VENDEUR de ses obligations et garanties visées aux présentes, LE VENDEUR s’engage à indemniser l’ACQUEREUR de
            toutes les conséquences financières liées à une telle réclamation ou à un tel recours.
          </Text>
          <Text style={styles.subtitle}>Article 5. Risques non-couverts</Text>
          <Text style={styles.subtitle2}>5.1. Risques économiques</Text>
          <Text style={styles.p}>L’ACQUEREUR reconnaît être averti des risques économiques suivants : </Text>
          <Text style={styles.p}>- le NFT peut perdre tout ou partie de sa valeur en raison de l’évolution du prix du marché ;</Text>
          <Text style={styles.p}>
            - les actifs numériques, jetons et NFT peuvent faire l’objet d'importantes fluctuations de prix à la hausse comme à la baisse. L'amplitude
            de telles fluctuations est difficile à prévoir et ne saurait être garantie ;
          </Text>
          <Text style={styles.p}>
            - l’ACQUEREUR n’a aucune garantie de pouvoir lister le NFT sur une plateforme ou marché secondaire et l’ACQUEREUR n’a ainsi aucune
            garantie de pouvoir revendre le NFT.
          </Text>
          <Text style={styles.subtitle2}>5.2. Risques technologiques</Text>
          <Text style={styles.p}>L’ACQUEREUR reconnaît être averti des risques technologiques suivants :</Text>
          <Text style={styles.p}>
            - Le NFT est stockés dans un portefeuille électronique auquel est associé une clé privée unique permettant de disposer du NFT. En
            conséquence, le vol, la perte ou le piratage de clés privées implique la perte définitive du NFT. L’ACQUEREUR est également responsable du
            stockage sécurisé de la clé privée de son portefeuille, nécessaire pour recevoir et transférer le NFT. La perte ou le vol de la clé privée
            équivaut à la perte du NFT attribué au portefeuille ;
          </Text>
          <Text style={styles.p}>
            - En cas transfert par l’ACQUEREUR vers un portefeuille incompatible avec le contrat intelligent du NFT, l’ACQUEREUR ne pourra normalement
            plus accéder au NFT. L’ACQUEREUR porte l'entière responsabilité de la décision quant au choix du portefeuille utilisé ;
          </Text>
          <Text style={styles.p}>
            - En cas de création ultérieure par l’ACQUEREUR d’un contrat intelligent portant sur le NFT cédant, l’ACQUEREUR porte l’entière
            responsabilité du choix du contrat intelligent standard ou ad hoc utilisé et des bugs et failles éventuelles de sécurité éventuelles.{' '}
          </Text>
          <Text style={styles.p}>
            - Le DEEP choisi est la blockchain publique {nft.network}, courant un risque d’une attaque du système de consensus dite attaque 51% pouvant
            corrompre les données inscrites sur la blockchain.
          </Text>
          <Text style={styles.subtitle2}>5.3. Risques réglementaires</Text>
          <Text style={styles.p}>L’ACQUEREUR reconnaît être averti des risques réglementaires suivants : </Text>
          <Text style={styles.p}>
            - Des risques juridiques et fiscaux liés à la détermination du droit applicable, notamment en cas de revente du NFT sont à prendre en
            compte par l’ACQUEREUR et le VENDEUR ne peut garantir une qualification juridique ou fiscale en raison de la diversité des lois nationales
            applicables en la matière et de leur évolution, potentiellement défavorable aux intérêts de l’ACQUEREUR ;
          </Text>
          <Text style={styles.p}>
            - Des modifications réglementaires ou normatives pourraient avoir des incidences sur le fonctionnement du DEEP blockchain publique
            {nft.network} utilisée pour le NFT ce qui pourrait générer des risques juridiques et fiscaux divers ayant des conséquences notamment sur les
            conditions ou la possibilité même de revente du NFT ;
          </Text>
          <Text style={styles.p}>
            - Des risques liés à des obligations renforcées d’identification de l’ACQUEREUR pour conserver, utiliser et/ou revendre le NFT doivent
            être pris en compte et ne peuvent être couverts par le VENDEUR.
          </Text>
          <Text style={styles.subtitle}>Article 6. Défense des droits</Text>
          <Text style={styles.p}>L’ACQUEREUR ne dispose pas du droit à agir directement en contrefaçon.</Text>
          <Text style={styles.subtitle}>Article 7. Exécution </Text>
          <Text style={styles.subtitle2}>7.1. Exécution automatique par contrat intelligent</Text>
          <Text style={styles.p}>
            Le transfert du NFT sur le portefeuille de l’ACQUEREUR est réalisé automatiquement par l’envoi des sommes déterminées selon l’article 3,
            via contrat intelligent de sur le DEEP blockchain publique {nft.network}. L’octroi des droits d’utilisation visés à l’article 2 intervient dès
            la mise en possession du NFT sur le portefeuille de l’ACQUEREUR et perdure tant que le NFT est détenu sur un portefeuille dont l’ACQUEREUR
            est titulaire.
          </Text>
          <Text style={styles.subtitle2}>7.2. Renonciation au droit de rétractation</Text>
          <Text style={styles.p}>
            Conformément aux dispositions légales en vigueur, l’ACQUEREUR renonce expressément à son droit de rétractation dès la livraison des actifs
            numériques formalisés par le NFT par exécution automatique du contrat intelligent. La présente vente de NFT est ferme est définitive.
            Aucune demande de rétractation, annulation ou remboursement ne sera traitée.
          </Text>
          <Text style={styles.subtitle}>Article 8. Revente</Text>
          <Text style={styles.subtitle2}>8.1. Conditions de revente </Text>
          <Text style={styles.p}>
            L’ACQUEREUR est autorisé à revendre, sans accord préalable du VENDEUR, à tout tiers de son choix le NFT avec les droits d’utilisation
            associés, dans les mêmes conditions que celles stipulées aux présentes CGVNFT. Le NFT ne peut être revendu par l’ACQUEREUR sans transfert
            des droits d’utilisation associés et vice-versa. Le transfert du NFT entre portefeuilles électroniques détenus par l’ACQUEREUR n’est pas
            assimilé à une revente.
          </Text>
          {nft.resale && (
            <>
              <Text style={styles.subtitle2}>8.2. Droit de suite contractuel</Text>
              <Text style={styles.p}>
                L’ACQUEREUR s’assurera en cas de revente du NFT à un tiers 
                par voie de contrat intelligent ou par voie de transfert de propriété d’un
                portefeuille électronique décentralisé, centralisé, numérique ou 
                physique qu’un pourcentage de {nft.resaleValue} % sur le total du prix de 
                revente sera normalement versé automatiquement ou en cas d’impossibilité
                sera reversé dans un délai maximal de 14 jours au VENDEUR.
                Si le VENDEUR est différent de l’auteur, il fera son affaire du 
                reversement de ces sommes à l’auteur, une fois perçues.
                Cette somme devra être versée sur le portefeuille identifié par 
                l’adresse {nft.address} du DEEP blockchain publique {nft.network}.
              </Text>
            </>
          )}
          <Text style={styles.subtitle}>Article 9. Loi applicable </Text>
          <Text style={styles.p}> Les présentes CGVNFT sont régies par la loi française.</Text>
          <Text style={styles.subtitle}>Article 10. Litiges </Text>
          <Text style={styles.p}>
            Les Parties tenteront de régler tout différend résultant de l’interprétation ou de l’exécution des présentes CGVNFT de façon amiable. À
            défaut, tout litige sera soumis à la compétence des juridictions du ressort de la Cour d’Appel de Paris.
          </Text>
        </View>
      </Page>
    </Document>
  );
};
